<template>
    <div>
        <div class="footer">
            <span style="cursor: pointer;" v-show="flag !== item.id" @click="flag = item.id">回复</span>
            <span style="cursor: pointer;" v-show="flag === item.id" @click="flag = 0">取消回复</span>
            <span style="cursor: pointer; float: left;" v-show="res !== item.id" @click="res = item.id">展开</span>
            <span style="cursor: pointer; float: left;" v-show="res === item.id" @click="res = 0">收起</span>
        </div>
        <div v-show="flag === item.id"> <!-- 写回复评论 -->
            <el-input
                type="textarea"
                :rows="2"
                placeholder="在这里写评论..."
                v-model="reply">
            </el-input>
            <div style="text-align: right; padding-right: 40px; padding-top: 10px;">
                <span style="color: #95A5A6; cursor: pointer; font-size: 14px;" @click="CreateReply">提交评论</span>
            </div>
        </div>
        <div class="body" v-show="res === item.id" v-for="l in list" :key="l.id" >
            <div class="body-content" @mouseover="showText = l.id" @mouseleave="showText = 0">
                <div style="height: auto; width: 30px; padding-left: 10px;">
                    <img :src="l.photo" style=" border-radius: 50%; margin-top: 5px;" width="30px" height="30px" alt="你的头像">
                </div>
                <div style="margin-left: 17px; height: auto;"> 
                    <p style="font-size: 13px; color: orange; margin-top: 5px; ">{{ l.userName }} 
                        <span style="color: #909399; margin-left: 5px;">{{ l.createTime }}</span>
                        <span @click="deleteReply(l.id)" v-if="showText == l.id && item.userId == $store.state.me.id" style="margin-left: 10px; color: #25BB9B; cursor: pointer;">删除</span>
                    </p>
                    <pre style="white-space: pre-wrap; width: 1000px; height: auto; overflow-wrap: break-word; word-wrap: break-word;">{{ l.content }}</pre>
                    <div style="cursor: pointer; width: 1000px;font-size: 14px;">
                        <span v-show="l.otherName !== 'null'" style="font-size: 14px; color: #909399;">
                            回复 @{{ l.otherName }}
                        </span>
                        <span v-show="ans == 0" style="float: right; padding-right: 10px; color: #25BB9B;" @click="ans = l.id">回复</span>
                        <span v-show="ans == l.id" style="float: right; padding-right: 10px; color: #25BB9B;" @click="ans = 0">收回</span>
                        <el-input
                            v-show="ans == l.id"
                            style="width: 1000px; margin-top: 10px;"
                            type="textarea"
                            :rows="2"
                            placeholder="在这里写评论..."
                            v-model="content">
                        </el-input>
                        <span v-show="ans == l.id" style="color: #909399; padding-top: 4px; padding-right: 20px; float: right; cursor: pointer;" @click="replylll(l)">提交评论</span>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import Url from '@/constant/Url';

    export default {
        props:["item"],
        data() {
            return {
                res: 0,
                flag: 0,
                ans: 0,
                reply:'',
                content:'',

                list:[],
                showText: 0,
            }
        },
        mounted() {
            this.ReadReply()
        },
        methods: {
            deleteReply(id) {
                const vue = this
                const store = this.$store

                $.ajax({
                    url: Url.dCourseReplyUrl,
                    type: 'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        id: id,
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            vue.ReadReply()
                        }
                    }
                })
            },
            CreateReply() {
                const vue = this
                const store = this.$store

                $.ajax({
                    url: Url.cCourseReplyUrl,
                    type: 'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        userId: store.state.me.id,
                        userName: store.state.me.name,
                        otherId: 0, // 这个是回复主贴的 那么就是0
                        otherName: "null",
                        photo: store.state.me.photo,
                        content: vue.reply,
                        cardId: vue.item.id,
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            vue.ReadReply()
                            vue.flag = 0
                            vue.reply = ''
                        }
                    }
                })
            },
            ReadReply() {
                const vue = this
                const store = this.$store

                $.ajax({
                    url: Url.rCourseReplyUrl,
                    type: 'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        cardId: vue.item.id,
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            vue.list = JSON.parse(resp.list)
                        }
                    }
                })
            },
            replylll(item) {
                const vue = this
                const store = this.$store

                $.ajax({
                    url: Url.cCourseReplyUrl,
                    type: 'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        userId: store.state.me.id,
                        userName: store.state.me.name,
                        otherId: item.userId, // 这个是回复主贴的 那么就是0
                        otherName: item.userName,
                        photo: store.state.me.photo,
                        content: vue.content,
                        cardId: vue.item.id,
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            vue.ReadReply()
                            vue.ans = 0
                            vue.content = ''
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>
.body {
    margin-top: 6px;
    width: 1020px;
    height: auto;
    margin-bottom: 10px;
}
.body-content {
    display: flex;
    float: left;
    width: 1050px;
    background-color: #F2F2F2;
}
.footer {
    text-align: right;
    font-size: 14px;
    height: 34px;
    padding-top: 3px;
    padding-right: 2px;
    width: 100%;
    color: #25BB9B;
}
</style>